import { Typography } from '../../../../components/common';
import  { FilterFields } from '../Filters/FilterMenu';
import './filterHeader.scss';
import { useEffect, useMemo, useState } from 'react';
import SortAndFilterMenu from 'components/common/SortAndFilterMenu/sort-and-filter-menu';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface FilterHeaderProps {
  heading: string;
  numbersOptions: string[];
  queuesOptions: string[];
  onApplyFilters: (bulkFilters: any) => void;
  currentFilters: any;
}

const FilterHeader = ({ heading, numbersOptions, queuesOptions, onApplyFilters, currentFilters }: FilterHeaderProps) => {
  const agents = useSelector((state: RootState) => state.agents.items)
  
  const [localFilters, setLocalFilters] = useState<any>({})

  useEffect(() => {
    setLocalFilters(currentFilters || {})
  }, [currentFilters])

  const handleFilterChange = (fieldName: string, value: any) => {
    setLocalFilters((prev: any) => ({ ...prev, [fieldName]: value }))
  }

  const handleApplyFilters = () => {
    onApplyFilters(localFilters)
  }

  const handleClearFilters = () => {
    const cleared = Object.keys(localFilters).reduce((acc: any, key: string) => {
      if (key.startsWith('sort')) {
        acc[key] = localFilters[key]
      } else {
        acc[key] = null
      }
      return acc
    }, {})
    setLocalFilters(cleared)
    onApplyFilters(cleared)
  }

  const agentsOptions = useMemo(() => {
    return agents?.map((agent: any) => ({ label: agent.name, value: agent.id })) || []
  }, [agents])

  const treeValue = useMemo(() => {
    if (currentFilters?.sortQueue) return currentFilters.sortQueue
    if (currentFilters?.sortDuration) return currentFilters.sortDuration
    if (currentFilters?.sortTime) return currentFilters.sortTime
    if (currentFilters?.sortAgent) return currentFilters.sortAgent
    return undefined
  }, [currentFilters])

  const handleTreeChange = (value: string | undefined) => {
    const update: any = {
      sortQueue: null,
      sortDuration: null,
      sortTime: null,
      sortAgent: null,
    }
    if (value?.startsWith('queue-')) update.sortQueue = value
    else if (value?.startsWith('duration-')) update.sortDuration = value
    else if (value?.startsWith('time-')) update.sortTime = value
    else if (value?.startsWith('agent-')) update.sortAgent = value
    onApplyFilters({ ...currentFilters, ...update })
  }

  const treeData = [{
    title: <span className="select-tree-parent">Queue Name</span>,
    value: 'queue',
    key: 'queue',
    selectable: false,
    children: [
      { title: 'Ascending', value: 'queue-asc', key: 'queue-asc' },
      { title: 'Descending', value: 'queue-desc', key: 'queue-desc' },
    ],
  },
  {
    title: <span className="select-tree-parent">Call Duration</span>,
    value: 'duration',
    key: 'duration',
    selectable: false,
    children: [
      { title: 'Shortest → Longest', value: 'duration-asc', key: 'duration-asc' },
      { title: 'Longest → Shortest', value: 'duration-desc', key: 'duration-desc' },
    ],
  },
  ...(Object.prototype.hasOwnProperty.call(currentFilters || {}, 'sortTime') ? [{
    title: <span className="select-tree-parent">Time</span>,
    value: 'time',
    key: 'time',
    selectable: false,
    children: [
      { title: 'Newest → Oldest', value: 'time-desc', key: 'time-desc' },
      { title: 'Oldest → Newest', value: 'time-asc', key: 'time-asc' },
    ]
  }] : []),
  ...(Object.prototype.hasOwnProperty.call(currentFilters || {}, 'selectedAgent')
    ? [
      {
        title: <span className="select-tree-parent">Agent Name</span>,
        value: 'agent',
        key: 'agent',
        selectable: false,
        children: [
          { title: 'Ascending', value: 'agent-asc', key: 'agent-asc' },
          { title: 'Descending', value: 'agent-desc', key: 'agent-desc' },
        ],
      },
    ]
    : []),
  ]

  return (
    <div className="filter-header-container">
      <div className="icon-heading-container">
        <div className="icon-container">
          <i className="bx bxs-phone"></i>
        </div>
        <Typography variant="subText">{heading}</Typography>
      </div>

      <SortAndFilterMenu
        treeData={treeData}
        treeValue={treeValue}
        handleTreeChange={handleTreeChange}
        onApplyFilters={handleApplyFilters}
        onClear={handleClearFilters}
      >
        <FilterFields
          currentFilters={currentFilters}
          localFilters={localFilters}
          handleFilterChange={handleFilterChange}
          numbersOptions={numbersOptions}
          queuesOptions={queuesOptions}
          agentsOptions={agentsOptions}
        />
      </SortAndFilterMenu>
    </div>
  );
};

export default FilterHeader;
